import { Skeleton } from "antd";
import { useFetchLocalStorage } from "lib/useFetchLocalStorage";
import useUser from "lib/useUser";
import DatelineTemplateList from "components/job/dateline/template/list";
import SectionTitle from "components/shared/SectionTitle";
import * as ROUTES from "constants/routes";

function DatelineTemplate() {
  useFetchLocalStorage();
  const { status, user } = useUser({ redirectTo: "/login" });

  if (status === "loading" || !user) return <Skeleton active />;

  return (
    <>
      <SectionTitle
        title="Dateline Template List"
        buttonTo={ROUTES.DATELINE_TEMPLATE_ADD}
        buttonTitle="Add Template"
      />
      <DatelineTemplateList />
    </>
  );
}

export default DatelineTemplate;
